import { isApp, skipCourseDetailScreen, fileDownload } from './client'
import router from '@/router/index'
import { isFeishu, saveImageToAlbum } from '@/utils/feishu'
import { isTudoApp, tudoSetTitle } from './tudo'
import { isWisdomRabbitApp, wisdomRabbitSetTitle } from './sandsTalkSmartRabbit'
import { setTitle as setTitleForClient } from './client'
import { isWechat, isComWx } from '@/utils/weixin'
import { isSandsTalkFlutterApp, sandsTalkFlutterSetTitle } from './sandsTalkFlutter'
import { isSandsTalkMSFlutterApp, sandsTalkMSFlutterSetTitle } from './sandsTalkMSFlutter'
import { sandsTalkVnNativeTitle } from './sandsTalkNative'
import { isSandsTalkPhOutfieldApp, sandsTalkPhSetTitle } from '@/utils/sandsTalkPhOutfiled'
import { chijunSetTitle } from '@/utils/sandsTalkCnDriverApp'

interface SkipCourseDetailParams {
  id: number // 课程包id
  courseId: number // 课件id
  courseType: string
  endingType: string
  channel?: string
  trySeeSpuId?: number
}
const skipCourseDetail = (data: SkipCourseDetailParams) => {
  if (isApp) {
    skipCourseDetailScreen(data)
  } else {
    let queryParams = {
      id: undefined as number | undefined,
      courseId: undefined as number | undefined,
      courseType: data.courseType,
      endingType: data.endingType,
      channel: data.channel,
      trySeeSpuId: data.trySeeSpuId
    }
    if (data.courseId === -1) {
      // 课程包
      queryParams.id = data.id as number
    } else if (data.id === -1) {
      // 课件
      queryParams.id = data.courseId as number
    } else if (data.id !== -1 && data.courseId !== -1) {
      // 课程包下的课件
      queryParams.id = data.courseId
      queryParams.courseId = data.id as number
    }
    router.push({
      name: 'courseDetail',
      query: queryParams
    })
  }
}

const getType = (url: string) => {
  const arr = url.split('.')
  const suffix = arr[arr.length - 1]
  return suffix.split('?')[0]
}

interface SaveImageParams {
  url: string
  callback?: () => void
}
export const saveImage = (data: SaveImageParams) => {
  const { url, callback = () => {} } = data
  if (!url) {
    return
  }
  const fullUrl = url.split('?')[0]
  if (isApp) {
    fileDownload({
      fileType: getType(url),
      docName: '',
      fromUrl: fullUrl,
      callback
    })
  } else if (isFeishu) {
    saveImageToAlbum({
      url: fullUrl,
      callback
    })
  }
}

export { skipCourseDetail }

export const noNavBar =
  isFeishu ||
  isApp ||
  isTudoApp ||
  isWechat ||
  isComWx ||
  isSandsTalkFlutterApp ||
  isSandsTalkMSFlutterApp ||
  isSandsTalkPhOutfieldApp ||
  isWisdomRabbitApp ||
  localStorage.getItem('isCnDriverAppSource') === 'cnChijunApp'

export const setTitle = async (str: string) => {
  // alert('setTitle' + str)
  if (isApp) {
    setTitleForClient(str)
  } else if (isTudoApp) {
    tudoSetTitle(str)
  } else if (isWisdomRabbitApp) {
    wisdomRabbitSetTitle(str)
  } else if (isSandsTalkFlutterApp) {
    sandsTalkFlutterSetTitle(str)
  } else if (isSandsTalkMSFlutterApp) {
    sandsTalkMSFlutterSetTitle(str)
  } else if (isSandsTalkPhOutfieldApp) {
    sandsTalkPhSetTitle(str)
  } else if (localStorage.getItem('isCnDriverAppSource') === 'cnChijunApp') {
    chijunSetTitle(str)
  } else if (window.jt || (!window.jt && window.flutter_inappwebview)) {
    // 越南标题
    sandsTalkVnNativeTitle(str)
  } else {
    document.title = str
  }
}
